export const APPLICATION_NAME = "XXX";
export const APPLICATION_NAME_NORMAL = "XXX";
export const APP_VERSION = "2.0.0";

export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;

export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;

export const googlePlacesKey = "AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4";

export const SPLASH_SCREEN_DURATION_IN_MILLISECONDS = 400;

export const keyboardTypeEnum = {
  default: "default",
  email: "email-address",
  numeric: "number-pad",
  decimal: "decimal-pad",
  phone: "phone-pad",
};

export const FRONT_URL = "https://www.playbun.com/";

export const LOGOUT = "logout";

export const AUTH_TYPE = {
  BASIC: "BASIC",
  TELEGRAM: "TELEGRAM",
  GOOGLE: "GOOGLE",
  DISCORD: "DISCORD",
};

export const MAX_USAGE_AFFILIATE = 400;

export const COLLECTION_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  NUDIFY_IN_PROGRESS: "NUDIFY_IN_PROGRESS",
  UPSCALE_IN_PROGRESS: "UPSCALE_IN_PROGRESS",
  AUDIO_IN_PROGRESS: "AUDIO_IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
};

export const DISCORD_CLIENT_ID = "1510272302682607797";

export const REGENERATE_DISCOUNT_PERCENTAGE = 0.15; // 15%
export const NUDIFY_PRICE = 15;
export const UPSCALE_PRICE = 15;
export const AUDIO_PRICE = 5;

export const MEDIA_TYPE = {
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
};

export const VIDEO_RESOLUTION = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const ALL_VIDEO_RESOLUTIONS = [
  VIDEO_RESOLUTION.LOW,
  VIDEO_RESOLUTION.MEDIUM,
  VIDEO_RESOLUTION.HIGH,
];

export const DEFAULT_VIDEO_FPS = 45;
export const DEFAULT_VIDEO_DURATION = 5;

export const DEFAULT_VIDEO_RESOLUTION = VIDEO_RESOLUTION.MEDIUM;

export const VIDEO_RESOLUTION_PRICE = {
  LOW: 0,
  MEDIUM: 0,
  HIGH: 20,
};

export const VIDEO_RESOLUTION_TO_TIME = {
  LOW: "2-3",
  MEDIUM: "3-5",
  HIGH: "4-10",
};

export const VIDEO_DURATION_PRICE = {
  5: 0,
  7: 20,
  8: 20,
  10: 40,
  12: 50,
};

export const VIDEO_FPS_PRICE = {
  30: 0,
  45: 0,
  60: 10,
};

export const PRO_VIDEO_DURATION = [10, 12];

export const MAX_VIDEO_SIZE = 30 * 1024 * 1024; // 30 MB

export const MAX_IMAGE_SIZE = 30 * 1024 * 1024; // 7 MB;

export const NUDIFY_MODEL_NAME = "GETTING_NAKED";
export const TEXT_ON_BODY_MODEL_NAME = "TEXT_ON_BODY";
export const EDIT_IMAGE_MODEL_NAME = "EDIT_PHOTO";
export const CHANGE_ANGLE_MODEL_NAME = "Change Angle";
export const CREATE_IMAGE_MODEL_NAME = "CREATE_IMAGE";
export const QWEN_Z_MODEL_NAME = "QWEN_Z";
export const QWEN_Z_TWO_INPUT_IMAGES = "QWEN_Z_TWO_INPUT_IMAGES";
export const QWEN_Z_THREE_INPUT_IMAGES = "QWEN_Z_THREE_INPUT_IMAGES";
export const BLEND_MODEL = "BLEND_MODEL";
export const UPSCALE = "UPSCALE";

export const TRAIN_MODEL_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED_FOR_TRAINING: "SUBMITTED_FOR_TRAINING",
  TRAINING: "TRAINING",
  TRAINING_COMPLETED: "TRAINING_COMPLETED",
  GENERATING_COLLECTIONS: "GENERATING_COLLECTIONS",
  COLLECTIONS_CREATED: "COLLECTIONS_CREATED",
  COMPLETED: "COMPLETED",
  SUBMITTED_FOR_REVIEW: "SUBMITTED_FOR_REVIEW",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  FAILED: "FAILED",
};

export const TRAIN_MODEL_STATUS_TEXT = {
  [TRAIN_MODEL_STATUS.IN_PROGRESS]: "Draft",
  [TRAIN_MODEL_STATUS.SUBMITTED_FOR_TRAINING]: "Submitted for training",
  [TRAIN_MODEL_STATUS.TRAINING]: "Training",
  [TRAIN_MODEL_STATUS.TRAINING_COMPLETED]: "Generating collections",
  [TRAIN_MODEL_STATUS.GENERATING_COLLECTIONS]: "Generating collections",
  [TRAIN_MODEL_STATUS.SUBMITTED_FOR_REVIEW]: "Submitted for review",
  [TRAIN_MODEL_STATUS.COLLECTIONS_CREATED]: "Train completed",
  [TRAIN_MODEL_STATUS.COMPLETED]: "Submit model for review",
  [TRAIN_MODEL_STATUS.ACCEPTED]: "Accepted model",
  [TRAIN_MODEL_STATUS.DECLINED]: "Declined. Not eligible.",
  [TRAIN_MODEL_STATUS.FAILED]: "Training failed.",
};

export const ASPECT_RATIONS = [
  {
    id: 1,
    label: "Original",
    value: null,
  },
  {
    id: 2,
    label: "16:9",
    value: 16 / 9,
  },
  {
    id: 3,
    label: "4:3",
    value: 4 / 3,
  },
  {
    id: 4,
    label: "1:1",
    value: 1,
  },
  {
    id: 5,
    label: "3:4",
    value: 3 / 4,
  },
  {
    id: 6,
    label: "9:16",
    value: 9 / 16,
  },
];

export const TAGS = [
  { id: 1, label: "Ass" },
  { id: 2, label: "Tits" },
  { id: 3, label: "Pussy" },
  { id: 4, label: "Penetration" },
  { id: 5, label: "Anal" },
  { id: 6, label: "Cumshot" },
  { id: 7, label: "Blowjob" },
  { id: 8, label: "Handjob" },
  { id: 9, label: "Footplay" },
  { id: 10, label: "Masturbation" },
  { id: 11, label: "Blowbang" },
  { id: 12, label: "Gangbang" },
  { id: 13, label: "Double Penetration (DP)" },
  { id: 14, label: "Softcore" },
  { id: 15, label: "BDSM" },
  { id: 16, label: "Undress" },
  { id: 17, label: "Lesbian" },
  { id: 18, label: "Trans" },
  { id: 19, label: "Gay" },
  { id: 20, label: "Disturbing" },
  { id: 21, label: "Fetish" },
  { id: 22, label: "Big Cock" },
  { id: 23, label: "Bukkake" },
  { id: 24, label: "Cartoon" },
  { id: 25, label: "Couple" },
  { id: 26, label: "Hairy" },
  { id: 27, label: "Pregnant" },
  { id: 28, label: "Sex Toy" },
  { id: 29, label: "BBC" },
  { id: 30, label: "Interracial" },
  { id: 31, label: "POV" },
  { id: 33, label: "Threesome" },
];

export const ALLOWED_TAGS = [
  { id: 1, label: "Ass" },
  { id: 2, label: "Tits" },
  { id: 3, label: "Pussy" },
  { id: 4, label: "Penetration" },
  { id: 5, label: "Anal" },
  { id: 6, label: "Cumshot" },
  { id: 7, label: "Blowjob" },
  { id: 8, label: "Handjob" },
  { id: 9, label: "Footplay" },
  { id: 10, label: "Masturbation" },
  { id: 11, label: "Blowbang" },
  { id: 12, label: "Gangbang" },
  { id: 13, label: "Double Penetration (DP)" },
  { id: 14, label: "Softcore" },
  { id: 15, label: "BDSM" },
  { id: 16, label: "Undress" },
  { id: 17, label: "Lesbian" },
  { id: 18, label: "Trans" },
  { id: 19, label: "Gay" },
  { id: 21, label: "Fetish" },
  { id: 22, label: "Big Cock" },
  { id: 23, label: "Bukkake" },
  { id: 24, label: "Cartoon" },
  { id: 25, label: "Couple" },
  //   { id: 26, label: "Hairy" },
  //   { id: 27, label: "Pregnant" },
  { id: 28, label: "Sex Toy" },
  { id: 29, label: "BBC" },
  { id: 30, label: "Interracial" },
  { id: 31, label: "POV" },
  { id: 33, label: "Threesome" },
  //   { id: 32, label: "Bizarre" },
];

export const BASIC_PLAN_NAME = "Basic";
export const PRO_PLAN_NAME = "Pro";
export const PREMIUM_PLAN_NAME = "Premium";

export const ENABLE_CREDIT_CARD_FOR_COUNTRIES = [
  "IR",
  "RU",
  "SD",
  "DE",
  "CN",
  "CU",
  "KE",
  "NP",
  "PK",
  "VN",
  "SO",
];

export const COLLECTION_GROUP_TYPE = {
  ANONYMIZE: "ANONYMIZE",
};

export const ALLOWED_HIDE_COLLECTION_USER_IDS = [
  "68de7e2db2fb0a3b2d0e97d1",
  "68de7d08e4cb20939e8f58b9",
  "68deed5534e37e911b3e4b6c",
];

export const BLOCK_USER_TO_TRAIN = [];

// Timezones for which AliPay / WeChat Pay payment options are shown.
export const ASIAN_PAYMENT_TIMEZONES = [
  // China
  "Asia/Shanghai",
  "Asia/Urumqi",

  // Hong Kong / Macau / Taiwan
  "Asia/Hong_Kong",
  "Asia/Macau",
  "Asia/Taipei",

  // Japan
  "Asia/Tokyo",

  // South Korea
  "Asia/Seoul",

  // Singapore
  "Asia/Singapore",

  // Malaysia
  "Asia/Kuala_Lumpur",

  // Thailand
  "Asia/Bangkok",

  // Indonesia
  "Asia/Jakarta",
  "Asia/Makassar",
  "Asia/Jayapura",

  // Philippines
  "Asia/Manila",

  // Vietnam
  "Asia/Ho_Chi_Minh",

  // Cambodia
  "Asia/Phnom_Penh",

  // Laos
  "Asia/Vientiane",

  // Myanmar
  "Asia/Yangon",

  // Brunei
  "Asia/Brunei",
];

// Browser language prefixes for which AliPay / WeChat Pay options are shown.
export const ASIAN_LANGUAGE_PREFIXES = [
  "zh", // Chinese
  "ja", // Japanese
  "ko", // Korean
  "vi", // Vietnamese
  "th", // Thai
  "id", // Indonesian
  "ms", // Malay
  "fil", // Filipino
  "tl", // Tagalog
];

// ISO 3166-1 alpha-2 country codes for which AliPay / WeChat Pay options are
// shown (mirrors ASIAN_PAYMENT_TIMEZONES).
export const ASIAN_PAYMENT_COUNTRY_CODES = [
  "CN", // China
  "HK", // Hong Kong
  "MO", // Macau
  "TW", // Taiwan
  "JP", // Japan
  "KR", // South Korea
  "SG", // Singapore
  "MY", // Malaysia
  "TH", // Thailand
  "ID", // Indonesia
  "PH", // Philippines
  "VN", // Vietnam
  "KH", // Cambodia
  "LA", // Laos
  "MM", // Myanmar
  "BN", // Brunei
];
